import type { Dispatch } from 'redux';

import logger from '../base/media/logger';
import { startScreenShareFlow } from '../screen-share/actions';

export * from './functions.any';


/**
 * Stops screen sharing when moving to a breakout room.
 * Ensures the action completes before room transition to prevent UI state desync.
 * This is especially important for Safari which may handle state updates differently.
 *
 * @param {Dispatch} dispatch - Redux dispatch function
 * @returns {Promise<void>} Resolves when screen sharing is completely stopped
 */
export async function stopScreenSharingWhileMovingBreakoutRoom(dispatch: Dispatch): Promise<void> {
    try {
        const result = await dispatch(startScreenShareFlow(false));

        // Ensure the promise resolves even if startScreenShareFlow doesn't return a promise
        return Promise.resolve(result);
    } catch (error) {
        // If startScreenShareFlow throws, log it but don't prevent the room transition
        logger.error('Failed to stop screen sharing during breakout room transition:', error);

        return Promise.resolve();
    }
}

